const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export default capitalizeFirstLetter;


export const isAuthenticated = () => {
    const tokens = JSON.parse(localStorage.getItem('tokens'));
    return tokens && tokens.access;
  };
  